import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "leftContent"];
import { Component } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { OLAF } from 'HubStyleTokens/colors';
import UIDialogHeader from '../dialog/UIDialogHeader';
import { callIfPossible } from '../core/Functions';
import { PanelNavigatorContext } from '../context/PanelNavigatorContext';
import { RegistersPanelHeader } from '../context/PanelComponentRegistrationContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LeftContentWrapper = styled.div.withConfig({
  displayName: "UIPanelHeader__LeftContentWrapper",
  componentId: "sc-1nmbbiu-0"
})(["position:relative;left:-12px;margin-right:28px;&::after{background-color:", ";content:'';height:32px;opacity:0.5;position:absolute;right:-21px;top:50%;transform:translateY(-50%);width:1px;}"], OLAF);
export default class UIPanelHeader extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      currentPanel: null
    };
  }
  componentDidMount() {
    const currentPanel = callIfPossible(this.context.getCurrentPanel);
    if (currentPanel) {
      this.setState({
        currentPanel
      });
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        leftContent
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      currentPanel
    } = this.state;
    const computedLeftContent = leftContent || callIfPossible(this.context.renderNavigation, currentPanel);
    const classes = classNames(className, 'private-panel__header');
    return /*#__PURE__*/_jsxs(UIDialogHeader, Object.assign({}, rest, {
      className: classes,
      children: [/*#__PURE__*/_jsx(RegistersPanelHeader, {}), computedLeftContent && /*#__PURE__*/_jsx(LeftContentWrapper, {
        children: computedLeftContent
      }), children]
    }));
  }
}
UIPanelHeader.propTypes = UIDialogHeader.propTypes;
UIPanelHeader.defaultProps = UIDialogHeader.defaultProps;
UIPanelHeader.contextType = PanelNavigatorContext;
UIPanelHeader.displayName = 'UIPanelHeader';